module.exports = __webpack_public_path__ + "img/L8.5663bcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cooperation/banner/L8.png
// module id = A3+m
// module chunks = 0